import { AsyncPipe, NgIf } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { Theme } from '@domgen/dgx-fe-common';
import { AddressToArrayPipe } from '@domgen/dgx-fe-components/general';
import {
  DescriptionListComponent,
  DescriptionListItemComponent,
} from '@domgen/dgx-fe-components/list';
import {
  PanelBorderRadius,
  PanelComponent,
} from '@domgen/dgx-fe-components/panel';
import {
  ConjunctionPipe,
  provideTranslationDictionaryMapping,
  TranslatePipe,
} from '@domgen/dgx-fe-i18n';
import { QMSanitiseDirective } from '@domgen/dgx-fe-qm';
import { CheckoutCustomerDetailsComponentService } from '../../services/checkout-customer-details-component/checkout-customer-details-component.service';
import { translation } from './i18n/translation.constant';

@Component({
  standalone: true,
  selector: 'checkout-customer-details',
  templateUrl: './checkout-customer-details.component.html',
  styleUrls: ['./checkout-customer-details.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    AddressToArrayPipe,
    AsyncPipe,
    ConjunctionPipe,
    DescriptionListComponent,
    DescriptionListItemComponent,
    NgIf,
    PanelComponent,
    QMSanitiseDirective,
    TranslatePipe,
  ],
  providers: [
    CheckoutCustomerDetailsComponentService,
    provideTranslationDictionaryMapping(translation),
  ],
})
export class CheckoutCustomerDetailsComponent {
  @Input() border = false;
  @Input() rounded?: PanelBorderRadius = 'lg';
  @Input() variant: Theme = 'background';

  constructor(readonly cs: CheckoutCustomerDetailsComponentService) {}
}
